<template>
  <div class="link-api" dir="rtl">
    <ul
      @mousedown="enterMouse"
      @mouseup="leaveMouse"
      @mousemove="moveMouse"
      class="link-api-menu flex flex-nowrap items-center gap-2 overflow-x-auto"
      ref="linkApiMenu"
    >
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        class="item shrink-0 cursor-pointer whitespace-nowrap rounded-full px-3 py-2"
        :class="tab.isActive ? 'active-link-api' : 'item-api'"
        :data-link-api-tour-step="tab.steps"
      >
        <span
          class="whitespace-nowrap text-sm font-semibold"
          :class="tab.special ? 'special' : ''"
        >
          {{ tab.title }}
        </span>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabsView",
  props: {
    selected: {
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      tabs: [], // all of the tabs
      movedMouse: false,
      startMove: undefined,
      move: undefined,
    };
  },
  mounted() {
    this.selectTab(this.selected);
  },
  methods: {
    selectTab(i) {
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
    enterMouse(e) {
      let innerSlider = document.querySelector(".item");
      this.movedMouse = true;
      this.startMove = e.offsetX - innerSlider.offsetLeft;
    },
    leaveMouse() {
      this.movedMouse = false;
    },
    moveMouse(e) {
      if (this.movedMouse) {
        let innerSlider = document.querySelector(".item");
        this.move = e.offsetX;
        innerSlider.style.left = `${this.x - this.startX}px`;
      }
    },
  },
  created() {
    this.tabs = this.$children;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_setting.scss";
</style>
